import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconGeoHollow: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="15" viewBox="0 0 15 15" width="15" {...props}>
        <path
            d="M2.832 6.782l4.143 1.204 1.235 4.159L12.926 2.07 2.832 6.781v.001zM15 0L8 14.95 6.171 8.794 0 7l15-7z"
            fill="currentColor"
            fillOpacity=".9"
        />
    </svg>
);
